// extracted by mini-css-extract-plugin
export default {"cls1":"DoubleDigitCountBubble-cls1__db0a5fff3281c6a6b483","cls2":"DoubleDigitCountBubble-cls2___94e02734cc4166b8317 DoubleDigitCountBubble-cls1__db0a5fff3281c6a6b483"};